import { Fragment } from 'react';
import * as Hero24Solid from '@heroicons/react/24/solid';
import * as Hero24Outline from '@heroicons/react/24/outline';
import * as Hero16Solid from '@heroicons/react/16/solid';

interface HeroIconProps {
  name: string;
  className?: string;
  variant?: 'solid' | 'outline' | 'solid16' | 'solid24' | 'outline24';
}

const variantMapping = {
  solid: Hero24Solid,
  solid24: Hero24Solid,
  outline: Hero24Outline,
  outline24: Hero24Outline,
  solid16: Hero16Solid,
};

export const HeroIcon: React.FC<HeroIconProps> = ({
  name,
  className,
  variant = 'outline',
  ...props
}: HeroIconProps) => {
  //@ts-expect-error Dynamic Import Types
  const Comp = variantMapping[variant][name + 'Icon'];
  return (
    <Fragment>
      {Comp ? <Comp className={className} {...props} /> : null}
    </Fragment>
  );
};
